import { AppThunk, AppDispatch } from '@app/store/store'
import { cmsSdk } from '@app/api/endpoints'
import { GetArticleQueryVariables, GetArticlesByParentQueryVariables } from '@app/graphql/cms/schema'

import { actions } from './slice'

export const getCategories = (): AppThunk => async (dispatch: AppDispatch) => {
  dispatch(actions.fetchCategories())
  try {
    const response = await cmsSdk.GetArticleParents()
    dispatch(actions.successFetchCategories(response.blogParents))
  } catch (error) {
    dispatch(actions.errorFetchCategories(error.errors?.[0]?.message))
  }
}

export const getCategory = (parentSlug: GetArticlesByParentQueryVariables['parentSlug']): AppThunk => async (
  dispatch: AppDispatch
) => {
  dispatch(actions.fetchCategory())
  try {
    const response = await cmsSdk.GetArticlesByParent({ parentSlug })
    dispatch(actions.successFetchCategory(response))
  } catch (error) {
    dispatch(actions.errorFetchCategory(error.errors?.[0]?.message))
  }
}

export const getArticle = (slug: GetArticleQueryVariables['slug']): AppThunk => async (dispatch: AppDispatch) => {
  dispatch(actions.fetchArticle())
  try {
    const response = await cmsSdk.GetArticle({ slug })
    dispatch(actions.successFetchArticle(response.blogPost))
  } catch (error) {
    dispatch(actions.errorFetchArticle(error.errors?.[0]?.message))
  }
}

export const resetStudioStatus = (): AppThunk => async (dispatch: AppDispatch) => {
  dispatch(actions.resetFetchStatus())
}
